import { useLocalStorageState } from "@datapay-by-datacom/design-system";
import { Logout, LogoutOptions, UseAuth, User } from "../types";
import { useMemo, useState } from "react";

function getMockUser(): User {
  return { name: "Mock User", email: "mock@example.com", sub: "user_id" };
}

function createMockJwt(): string {
  const encode = (obj: unknown) =>
    btoa(JSON.stringify(obj))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");
  const header = encode({ alg: "none", typ: "JWT" });
  const payload = encode({
    sub: "user_id",
    pacific_user_id: "mock-user-id",
    pacific_roles: ["AgenticUser"],
  });
  return `${header}.${payload}.mock`;
}

export function useMockAuth0(): UseAuth {
  const [user, setUser] = useLocalStorageState<User | null>("user", null);
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useLocalStorageState("token", "");

  const isAuthenticated = useMemo(() => user !== undefined, [user]);

  const loginWithRedirect = async () => {
    setIsLoading(true);
    // Simulate async login process
    setTimeout(() => {
      setToken(createMockJwt());
      setUser(getMockUser());
      setIsLoading(false);
    }, 500);
  };

  const logout: Logout = (_options?: LogoutOptions) => {
    setUser(null);
    setToken("");
  };

  return {
    isAuthenticated,
    user: user || undefined,
    logout,
    loginWithRedirect,
    getAccessTokenSilently: async () => token,
    isLoading,
    error: undefined,
  };
}
